import { z } from "zod";

/**
 * TanStack Router JSON-parses search parameter values before validation, so
 * text such as `123`, `true`, or `null` arrives as a JSON scalar rather than a
 * string. Normalize those values while ignoring structured values that cannot
 * represent a single text field.
 */
export const optionalStringSearchParam = z
  .union([z.string(), z.number(), z.boolean(), z.null()])
  .transform(String)
  .optional()
  .catch(undefined);
